import { useAccessBase } from '@/shared/modules/auth';
import { useCallback } from 'react';
// TODO: mb rename to useAccess
export const useAccess = () => {
    const { isAdmin, userClaims } = useAccessBase();
    const isCustomerManager = isAdmin || userClaims.includes('CustomerManager') || userClaims.includes('CustomerHeadManager');
    const isSupplierManager = isAdmin || userClaims.includes('SupplierManager') || userClaims.includes('SupplierHeadManager');
    const hasAccessTo = useCallback((...claims) => {
        if (isAdmin)
            return true;
        if (userClaims.some((userClaim) => claims.includes(userClaim)))
            return true;
        // To avoid this checks CustomerHeadManager and SupplierHeadManager roles should also have 'CustomerManager' and
        // 'SupplierManager' claims besides 'CustomerHeadManager' and 'SupplierHeadManager' claims.
        if (claims.includes('CustomerManager') && userClaims.includes('CustomerHeadManager'))
            return true;
        if (claims.includes('SupplierManager') && userClaims.includes('SupplierHeadManager'))
            return true;
        return false;
    }, [isAdmin, userClaims]);
    return {
        isAdmin,
        isCustomerManager,
        isSupplierManager,
        userClaims,
        userHasAccessTo: hasAccessTo,
    };
};
